// Modules
import { api } from "services/api/service";

// Constants
import {
	API_CREATE_RETRO_CLAIM,
	API_EDIT_RETRO_CLAIM,
	API_REJECT_RETRO_CLAIM,
	API_REQUEST_RETRO_CLAIM,
	API_GET_RETRO_CLAIM_LIST,
	API_APPROVE_RETRO_CLAIM,
	API_GET_RETRO_CLAIM_PERMISSIONS
} from "constants/api";

// Imported definitions
import type {
	ApiResponse,
	CreateRetroClaimResponse,
	RejectRetroClaimResponse,
	RequestApprovalRetroClaimResponse,
	GetRetroClaimListResponse,
	ApproveRetroClaimResponse,
	GetRetroClaimPermissionsResponse
} from "services/api/types";

// API to create retro claim
export const createRetroClaim = async (payload: any): Promise<ApiResponse<CreateRetroClaimResponse>> => {
	return (await api()).post(API_CREATE_RETRO_CLAIM, payload);
};

// API to approve retro claim
export const approveRetroClaim = async (payload: any): Promise<ApiResponse<ApproveRetroClaimResponse>> => {
	return (await api()).post(API_APPROVE_RETRO_CLAIM, payload);
};

// API to reject retro claim
export const rejectRetroClaim = async (payload: any): Promise<ApiResponse<RejectRetroClaimResponse>> => {
	return (await api()).post(API_REJECT_RETRO_CLAIM, payload);
};

// API to edit retro claim
export const editRetroClaim = async (payload: any): Promise<ApiResponse<CreateRetroClaimResponse>> => {
	return (await api()).post(API_EDIT_RETRO_CLAIM, payload);
};

// API to approvalRequest retro claim
export const approvalRequestRetroClaim = async (payload: FormData): Promise<ApiResponse<RequestApprovalRetroClaimResponse>> => {
	return (await api()).post(API_REQUEST_RETRO_CLAIM, payload, { headers: { "Content-Type": "multipart/form-data" } });
};

// API to GET retro claim LIST
export const getRetroClaimList = async (payload: any): Promise<ApiResponse<GetRetroClaimListResponse>> => {
	return (await api()).post(API_GET_RETRO_CLAIM_LIST, payload);
};

// API to GET retro claim permissions
export const getRetroClaimPermissions = async (payload: any): Promise<ApiResponse<GetRetroClaimPermissionsResponse>> => {
	return (await api()).post(API_GET_RETRO_CLAIM_PERMISSIONS, payload);
};
